<flo-article-view
  [articleView]="view$ | async"
  [adConfigMap]="adConfigs$ | async"
  [rightRailRelatedContent]="rightRailRelatedContent$ | async"
  [belowRelatedContent]="belowContent$ | async"
  (lazyLoadedAdRef)="adLoadedOnChildView($event)"
></flo-article-view>
